<template>
  <tbody>
    <tr
      v-for="(item, i) in items"
      :key="i"
      class="text-xs-left hovereable"
      @click="getNotificationSchedule(item.id)">
      <td width="120" class="text-xs-center">
        <v-avatar size="45" class="transparent">
          <v-icon large class="k-orange-linear-text">
            {{showIconChannel(item.channel_id)}}
          </v-icon>
        </v-avatar>
      </td>
      <td style="max-width: 300px">
        <p class="break-all">
          {{ item.name || item.first_name }} 
        </p>
        <v-icon class="green--text f1em pb-3" v-if="item.reviewed_at">
          far fa-check-circle
        </v-icon>
        <small v-if="item.type === 'test'">
          Prueba
        </small>
        <small v-else>
          Cuenta: {{ item.account }}
        </small>
      </td>
      <td>
        {{ item.to }}
        <small>
          {{showNameChannel(item.channel_id, 'upperAll')}}
        </small>
      </td>
      <td>
        {{ formatDate(item.local_schedule_date, 'YYYY-MM-DD','DD/MM/YYYY') }}
        <small>{{ formatDate(item.local_schedule_date, 'YYYY-MM-DD HH:mm:ss','h:mm A') }}</small>
      </td>
      <td width="130px">
        <span :class="getSpanColor(item.status_id)">
          {{ storeStatus(item.status_id).status  }}
          <v-icon small :class="getSpanColor(item.status_id, true)">
            {{ showStatusIcon(item.status_id) || 'fas fa-report_off' }}
           </v-icon>
        </span>
      </td>
    </tr>
  </tbody>
</template>

<script>
import EventBus from '@/event-bus';
import moment from 'moment';
import ChannelsMixins from '@/mixins/channels';
import StatusMixins from '@/mixins/status';
import { mapGetters } from 'vuex';

export default {
  props: ['items'],
  mixins: [
    ChannelsMixins,
    StatusMixins,
  ],
  computed: {
    ...mapGetters({
      storeStatus: 'status',
    }),
  },
  methods: {
    formatDate(date, firstFormat, dateFormat) {
      return moment(date, firstFormat).format(dateFormat);
    },
    getNotificationSchedule(id) {
      EventBus.$emit('showNotificationDetail', id);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/notification_schedule/NotificationScheduleList.vue